import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import './SavingSaved.css';

/**
 * Status line under the title, laid out as milegrid's: a 6px dot (green once
 * saved, amber while saving) followed by 12px muted text. Same data as before;
 * the icons and the details popover became the dot and an inline suffix.
 */
const SavingSaved = () => {
    const savingData = useSelector((state) => state.editor.savingData);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const dot = (color) => (
        <span className="SavedData-dot" style={{ background: color }} aria-hidden="true" />
    );
    const savedDetails = savingData?.lastSavedDateTime
        ? `${savingData.lastSavedDateTime}, ${savingData.fileSize}`
        : savingData?.fileSize;

    return (
        <div className={'SavedData-Conatiner'}>
            {savingData && (
                <>
                    {savingData.isSaving === 'Saving...' ? (
                        <>
                            {dot('#e0a83a')}
                            <span>{savingData.isSaving}</span>
                        </>
                    ) : savingData.isSaving === 'Saved' ? (
                        isSmallScreen ? (
                            // Show details in a tooltip on smaller screens
                            <Tooltip title={savedDetails}>
                                <span className="SavedData-text" style={{ cursor: 'pointer' }}>
                                    {dot('#3aa76d')}
                                    <span>Saved to Pad</span>
                                </span>
                            </Tooltip>
                        ) : (
                            <>
                                {dot('#3aa76d')}
                                <span>Saved to Pad &middot; {savedDetails}</span>
                            </>
                        )
                    ) : (
                        // Freshly loaded, nothing saved this session yet: the design's
                        // default line, with the file size when it is known.
                        <>
                            {dot('#3aa76d')}
                            <span>Saved to Pad &middot; {savingData.fileSize || 'Document'}</span>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default SavingSaved;
